import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material/styles';
import { Badge } from './Badge';
import { BadgeType, PartnerEnrollmentStatus } from './enums';
import { PartnerDescription } from './models/PartnerDescription';
import { PartnerEnrollmentStatusBadge } from './PartnerEnrollmentStatusBadge';

export const RenderEnrollmentBadge = ({
  enrollStatus,
  showManageRewards,
  partnerInfo,
  updateOpenEnrollmentModalState,
}:
{
  enrollStatus: PartnerEnrollmentStatus,
  showManageRewards?: boolean,
  partnerInfo?: Partial<PartnerDescription>,
  updateOpenEnrollmentModalState?: (event: boolean) => void,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  if (enrollStatus === PartnerEnrollmentStatus.ActionRequired ||
    enrollStatus === PartnerEnrollmentStatus.InProgress) {
    return <PartnerEnrollmentStatusBadge status={enrollStatus} />;
  }

  if (enrollStatus === PartnerEnrollmentStatus.Completed) {
    if (showManageRewards) {
      return (
        <Badge
          badgeType={BadgeType.ManageRewards}
          badgeText={t('button.manageRewards')}
          isButton={true}
          optionalStyles={{
            backgroundColor: theme.palette.common.white,
            borderColor: theme.palette.brand.primary,
            color: theme.palette.brand.primary,
          }}
          redirectPath={partnerInfo?.redirectPath}
          onNavigate={partnerInfo?.onNavigate}
          updateOpenEnrollmentModalState={updateOpenEnrollmentModalState}
        />
      );
    }
    return (
      <Badge
        badgeType={BadgeType.Enrolled}
        badgeText={t('button.enrolled')}
        badgeSubtitle={t('partners.noCashBack')}
      />
    );
  }
  return (
    <Badge
      badgeType={BadgeType.NotEnrolled}
      badgeText={t('button.AddRewards')}
      isButton={true}
      optionalStyles={{
        backgroundColor: theme.palette.brand.primary,
        borderColor: theme.palette.brand.primary,
      }}
      redirectPath={partnerInfo?.redirectPath}
      onNavigate={partnerInfo?.onNavigate}
      updateOpenEnrollmentModalState={updateOpenEnrollmentModalState}
    />
  );
};
